<ngx-ui-loader fgsSize="75" fgsType="three-bounce" [hasProgressBar]="false" fgsColor="#ffffff"
  overlayColor="rgba(0,0,0,0.29)" blur="0"></ngx-ui-loader>
<router-outlet></router-outlet>
